export const RESERVATION_INFO_TYPE = 'reservationInfo'
export const LEGAL_CONDITIONS_TYPE = 'legalConditions'

export const DRAWER_CONTENT_TYPE = {
  RESERVATION_INFO: 'reservationInfo',
  RESERVATION_TERMS: 'reservationTerms',
  RESERVATION_LEGAL_CONDITIONS: 'reservationLegalConditions'
}

export const RESERVATION_STATUSES = {
  NON_RESERVABLE: 'non_reservable',
  RESERVABLE: 'reservable',
  OWN_RESERVATION: 'own_reservation',
  OTHER_RESERVATION: 'other_reservation'
}

export const RESERVATION_EVENTS_TRACKING = {
  RESERVATION_INFORMATION_CLICKED: 'Reservation Information Clicked',
  RESERVATION_START_CLICKED: 'Reservation Start Clicked',
  RESERVATION_MORE_INFORMATION_CLICKED: 'Reservation More Information Clicked',
  RESERVATION_MANAGE_CLICKED: 'Reservation Manage Clicked',
  RESERVATION_MODAL_CLOSED: 'Reservation Faq Modal Closed'
}
